import { Alert, AlertType } from '@design/components/alert/Alert';
import { useDismissContinuous } from '@terminal/hooks/use-dismiss-continuous/useDismissContinuous';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DISMISSED_KEY = '__toggle_dismissed_card_error';

export interface AlertCardErrorProps {
  openEditCardModal: () => void;
  hasError: boolean;
}

export const AlertCardError = ({
  openEditCardModal,
  hasError,
}: AlertCardErrorProps) => {
  const { t } = useTranslation('subscription');

  const { isVisible, handleDismiss } = useDismissContinuous({
    cookieKey: DISMISSED_KEY,
    overrideIsVisible: hasError,
  });

  const onClick = () => {
    handleDismiss();
    openEditCardModal();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Alert
      data-testid="card-error-toast-alert"
      title={t('subscription:alerts.paymentMethodExpiring.titleExpired')}
      message={t(
        'subscription:alerts.paymentMethodExpiring.notificationMessage'
      )}
      type={AlertType.Error}
      primaryBtn={{
        label: t('subscription:alerts.paymentMethodError.primaryBtnLabel'),
        onClick,
      }}
      onClose={handleDismiss}
    />
  );
};
